module.exports = __webpack_public_path__ + "img/hebgydx.4ebb6d78.jpg";